export { ActivityGroupMultiAvatar } from './ActivityGroupMultiAvatar';
